import { Result, Button, Card } from "antd";
import { Link, useNavigate } from "react-router-dom";

const NoPage = () => {
  return (
    <Card>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary">
            <Link to="/app">Back Home</Link>
          </Button>
        }
      />
    </Card>
  );
};

export default NoPage;
